/* src/app/modules_v2/admin/admin-verifactu-authorization/admin-verifactu-authorization.component.css */
.nav-pills .nav-link {
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
}
.nav-link.active {
  background-color: var(--cf-brand-dark);
  color: white;
  transition: all 0.2s ease-in-out;
  border-radius: 0.25rem;
}
.nav-link:not(.disabled):hover {
  background-color: var(--cf-brand-dark);
  color: white;
  transform: scale(1.02);
  cursor: pointer;
}
/*# sourceMappingURL=admin-verifactu-authorization.component.css.map */
